export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-GB": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Server Error"])},
        "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Something went wrong, we are working on a fix!"])}
      },
      "nl-NL": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serverfout"])},
        "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er ging iets mis, we werken aan een oplossing!"])}
      }
    }
  })
}
